import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { cn } from '~/core/ui/utils'
import SectionContainer from '../LandingPage/components/section/SectionContainer'
import { TypographyText } from '~/core/ui/Text'
import Image from 'next/image'

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M11.6667 8.16663L14.5833 9.33329H23.3333V12.8333H11.6667V8.16663Z"
      fill="#D4DAE0"
    />
    <path
      d="M11.6667 21L14.5833 22.1667H23.3333V25.6667H11.6667V21Z"
      fill="#D4DAE0"
    />
    <path
      d="M10.8708 10.9238V5.62109C10.8708 4.84759 11.1783 4.10555 11.7253 3.55859L11.9391 3.36523C12.4581 2.93987 13.1108 2.70413 13.7878 2.7041H15.9088C16.3616 2.7041 16.8085 2.8102 17.2135 3.0127L17.3629 3.09277C17.7053 3.28965 18.0051 3.55418 18.2428 3.87109L18.9586 4.82617H21.2126C21.9858 4.82629 22.7272 5.13305 23.2741 5.67969L23.4684 5.89355C23.8937 6.41253 24.1285 7.06535 24.1286 7.74219V10.9238C24.1286 11.6006 23.8936 12.2535 23.4684 12.7725L23.2741 12.9863C22.7272 13.5332 21.9859 13.8407 21.2126 13.8408H13.7878C13.1109 13.8408 12.4581 13.6059 11.9391 13.1807L11.7253 12.9863C11.1784 12.4394 10.8708 11.6973 10.8708 10.9238ZM12.4626 10.9238C12.4626 11.2753 12.6018 11.6127 12.8503 11.8613L12.9479 11.9502C13.1837 12.1433 13.4803 12.25 13.7878 12.25H21.2126C21.564 12.2499 21.9006 12.1098 22.1491 11.8613L22.2379 11.7646C22.4312 11.5287 22.5378 11.2315 22.5378 10.9238V7.74219C22.5377 7.43471 22.4311 7.13816 22.2379 6.90234L22.1491 6.80469C21.9006 6.55641 21.5638 6.41711 21.2126 6.41699H18.5602C18.3101 6.41687 18.0746 6.2987 17.9245 6.09863L16.9694 4.82617C16.8767 4.70264 16.7639 4.59587 16.6354 4.51172L16.5016 4.43555C16.3176 4.34358 16.1146 4.2959 15.9088 4.2959H13.7878C13.4802 4.29593 13.1838 4.40251 12.9479 4.5957L12.8503 4.68359C12.6017 4.93219 12.4626 5.26952 12.4626 5.62109V10.9238Z"
      fill="#474C5E"
    />
    <path
      d="M10.8708 23.7572V18.4545C10.8708 17.681 11.1783 16.9389 11.7253 16.392L11.9391 16.1986C12.4581 15.7733 13.1108 15.5375 13.7878 15.5375H15.779V15.5385C16.319 15.5366 16.8493 15.6845 17.3102 15.9662L17.4801 16.0775C17.866 16.352 18.1802 16.7172 18.3942 17.142L18.4001 17.1537L18.404 17.1625L18.6471 17.6595H21.2126L21.5006 17.6732C22.1681 17.7395 22.7956 18.0347 23.2741 18.5131L23.4684 18.7269C23.8937 19.2459 24.1285 19.8987 24.1286 20.5756V23.7572C24.1286 24.4339 23.8935 25.0869 23.4684 25.6058L23.2741 25.8197C22.7272 26.3666 21.9859 26.6741 21.2126 26.6742H13.7878C13.1109 26.6742 12.4581 26.4393 11.9391 26.014L11.7253 25.8197C11.1784 25.2727 10.8708 24.5306 10.8708 23.7572ZM12.4626 23.7572C12.4626 24.1087 12.6018 24.4461 12.8503 24.6947L12.9479 24.7836C13.1837 24.9767 13.4803 25.0833 13.7878 25.0834H21.2126C21.564 25.0833 21.9006 24.9432 22.1491 24.6947L22.2379 24.598C22.4312 24.3621 22.5378 24.0648 22.5378 23.7572V20.5756C22.5377 20.2681 22.4311 19.9715 22.2379 19.7357L22.1491 19.6381C21.9316 19.4208 21.6466 19.2864 21.3434 19.2562L21.2126 19.2504H18.1559C17.85 19.2525 17.5695 19.0789 17.4352 18.8041L16.9743 17.8607V17.8597L16.9733 17.8578C16.8899 17.6923 16.7727 17.5468 16.6305 17.4301L16.4801 17.3236C16.2702 17.1953 16.0289 17.1281 15.7829 17.1293H13.7878C13.4802 17.1293 13.1838 17.2359 12.9479 17.4291L12.8503 17.517C12.6017 17.7656 12.4626 18.1029 12.4626 18.4545V23.7572Z"
      fill="#474C5E"
    />
    <path
      d="M11.0833 8.45837L11.1732 8.46326C11.6142 8.50826 11.9583 8.88047 11.9583 9.33337C11.9583 9.78628 11.6142 10.1585 11.1732 10.2035L11.0833 10.2084H4.08334C3.60009 10.2084 3.20834 9.81662 3.20834 9.33337C3.20834 8.85012 3.60009 8.45837 4.08334 8.45837H11.0833Z"
      fill="#474C5E"
    />
    <path
      d="M2.625 18.6666V1.16663C2.625 0.683377 3.01675 0.291626 3.5 0.291626C3.98325 0.291626 4.375 0.683377 4.375 1.16663V18.6666C4.375 20.111 5.55558 21.2916 7 21.2916H11.083L11.1729 21.2965C11.614 21.3414 11.958 21.7136 11.958 22.1666C11.958 22.6196 11.614 22.9919 11.1729 23.0367L11.083 23.0416H7C4.58909 23.0416 2.625 21.0775 2.625 18.6666Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path d="M17.634 15H23L25 12.5V21L17.5 24L17.634 15Z" fill="#D4DAE0" />
    <path d="M3 6.99997L7.5 5L6 8V23L3 24V6.99997Z" fill="#D4DAE0" />
    <path
      d="M18.25 7.32037V23.1827L24.75 20.3389V4.47662L18.25 7.32037ZM3.75 7.76275V23.1524L9.75 20.3516V4.29889L3.75 7.76275ZM11.25 20.3663L16.75 23.1163V7.27447L11.25 4.26568V20.3663ZM26.25 20.503C26.25 20.9996 25.956 21.4494 25.501 21.6485L17.8008 25.0176C17.597 25.1068 17.364 25.1004 17.165 25.001L10.4883 21.6622L4.02832 24.6778C3.19965 25.0643 2.25 24.4594 2.25 23.545V7.6192C2.25 7.17262 2.48825 6.75948 2.875 6.53619L10.125 2.35064L10.2119 2.30767C10.4204 2.22091 10.6593 2.23183 10.8604 2.34185L17.5361 5.9942L24.499 2.94928L24.6543 2.89264C25.4365 2.66443 26.25 3.24956 26.25 4.09478V20.503Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M14.4167 2.33368C14.4167 2.13237 14.2736 1.96442 14.0837 1.92548L13.9997 1.91669C13.7703 1.91685 13.5837 2.1031 13.5837 2.33368V4.74091C13.5837 5.11924 13.3019 5.43824 12.9264 5.48505C9.04521 5.969 5.96903 9.04546 5.48503 12.9265C5.43821 13.3019 5.11922 13.5837 4.74089 13.5837H2.33366C2.10309 13.5837 1.91683 13.7703 1.91667 13.9997C1.91667 14.2298 2.10355 14.4167 2.33366 14.4167H4.74089C5.11919 14.4167 5.43818 14.6985 5.48503 15.0739C5.96932 18.9542 9.0454 22.0294 12.9264 22.5134C13.3019 22.5602 13.5837 22.8792 13.5837 23.2575V25.6667L13.5925 25.7507C13.6313 25.9408 13.799 26.0835 13.9997 26.0837L14.0837 26.0749C14.2464 26.0415 14.3745 25.9134 14.4079 25.7507L14.4167 25.6667V23.2575C14.4167 22.8792 14.6985 22.5602 15.0739 22.5134C18.9549 22.0292 22.0302 18.9547 22.5143 15.0739L22.5446 14.9382C22.6422 14.6327 22.9274 14.4167 23.2585 14.4167H25.6667L25.7507 14.4079C25.9134 14.3745 26.0415 14.2464 26.0749 14.0837L26.0837 13.9997C26.0835 13.799 25.9408 13.6313 25.7507 13.5925L25.6667 13.5837H23.2585C22.8801 13.5837 22.5611 13.3019 22.5143 12.9265C22.0303 9.04528 18.9549 5.96914 15.0739 5.48505C14.6985 5.43822 14.4167 5.11922 14.4167 4.74091V2.33368ZM15.9167 4.10223C19.9483 4.8784 23.1201 8.05209 23.8962 12.0837H25.6667L25.863 12.0934C26.8287 12.1917 27.5834 13.0071 27.5837 13.9997L27.5739 14.196C27.4821 15.0978 26.7648 15.8151 25.863 15.9069L25.6667 15.9167H23.8962C23.12 19.948 19.9479 23.1191 15.9167 23.8952V25.6667L15.9069 25.863C15.8151 26.7648 15.0978 27.4821 14.196 27.5739L13.9997 27.5837C13.0071 27.5834 12.1917 26.8287 12.0934 25.863L12.0837 25.6667V23.8952C8.05236 23.1192 4.87961 19.9476 4.1032 15.9167H2.33366C1.27512 15.9167 0.416672 15.0582 0.416672 13.9997C0.416943 12.9408 1.27585 12.0837 2.33366 12.0837H4.1032C4.87933 8.05214 8.05184 4.87828 12.0837 4.10223V2.33368C12.0837 1.27586 12.9408 0.416959 13.9997 0.416687L14.196 0.426453C15.1623 0.524788 15.9167 1.34139 15.9167 2.33368V4.10223Z"
      fill="#474C5E"
    />
    <circle cx="14" cy="14" r="5" fill="#D4DAE0" />
    <path
      d="M18.25 14C18.25 11.6528 16.3472 9.75 14 9.75C11.6528 9.75 9.75 11.6528 9.75 14C9.75 16.3472 11.6528 18.25 14 18.25C16.3472 18.25 18.25 16.3472 18.25 14ZM19.75 14C19.75 17.1756 17.1756 19.75 14 19.75C10.8244 19.75 8.25 17.1756 8.25 14C8.25 10.8244 10.8244 8.25 14 8.25C17.1756 8.25 19.75 10.8244 19.75 14Z"
      fill="#474C5E"
    />
  </svg>
)

const UnlockGrowthAndCrossFunctionalSection: FCC<{ className?: string }> = ({
  className
}) => {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('allFeature:unlock_growth:section_1_content_title'),
      contentDescription: t(
        'allFeature:unlock_growth:section_1_content_description'
      ),
      iconType: ICON_1,
      contentImage: '/img/feature/lp/new/talent-intelligence-unlock01.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:unlock_growth:section_2_content_title'),
      contentDescription: t(
        'allFeature:unlock_growth:section_2_content_description'
      ),
      iconType: ICON_2,
      contentImage: '/img/feature/lp/new/talent-intelligence-unlock02.png',
      contentLink: '#'
    },
    {
      contentTitle: t('allFeature:unlock_growth:section_3_content_title'),
      contentDescription: t(
        'allFeature:unlock_growth:section_3_content_description'
      ),
      iconType: ICON_3,
      contentImage: '/img/feature/lp/new/talent-intelligence-unlock03.png',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="allFeature:unlock_growth:title"
      description="allFeature:unlock_growth:description"
      tagLabel="allFeature:unlock_growth:tag"
      tagColor="bg-purple-100 text-purple-800"
      className={cn(className, 'pb-5 my-[44px] desktop:my-[140px]')}>
      <div className="relative">
        <div className="flex flex-col tablet:flex-wrap tablet:flex-row align-middle w-full justify-center mt-10 border-gray-100 border border-r-0 border-b-0">
          {SECTIONS.map((item, index) => (
            <div
              key={index}
              className="flex-1 min-w-[50%] border-gray-100 border-r border-b">
              <div className="px-8 pb-8 pt-6 relative">
                <div className="absolute top-[18px] right-[18px]">
                  {item.iconType}
                </div>
                <TypographyText className="text-[23px] font-medium text-gray-900">
                  {item.contentTitle}
                </TypographyText>
                <TypographyText className="text-base font-normal text-gray-700 mt-1 min-h-[72px] max-w-[700px]">
                  {item.contentDescription}
                </TypographyText>
                <div className="mt-6">
                  <Image
                    src={item.contentImage}
                    width={1200}
                    height={0}
                    alt={`${item.contentImage}-image`}
                    className="h-auto"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default UnlockGrowthAndCrossFunctionalSection
